var React = require('react');

function CaretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 1L9 9.5L1 1","stroke":"#0000D8","strokeWidth":"2"}));
}

CaretInline.defaultProps = {"width":"18","height":"11","viewBox":"0 0 18 11","fill":"none"};

module.exports = CaretInline;

CaretInline.default = CaretInline;
